import { NuxtRuntimeConfig } from "@nuxt/types/config/runtime"
import { replaceUrlS3Helper } from "~/scripts/useful-functions"

export function replaceUrlS3(url: string | null, config: NuxtRuntimeConfig) {
  return replaceUrlS3Helper(url, config.cdnUrl, config.graphqlEndpoint)
}
